import React, { useEffect, useState } from 'react';
import { ActiveView } from '../components/screenshotter-menu-bar';
import ScreenshotterMenuBar from '../components/screenshotter-menu-bar';
import ScreenshotterCards from '../components/screenshotter-table';
import { useGetScreenshotterItemsQuery } from '../endpoints/screenshotter.endpoints';
import { ScreenshotterItem } from '../types/screenshotter.types';
import { Aperture, MoveUpRight } from 'lucide-react';

const ScreenshotterTab: React.FC = () => {
  const [selectedScreenshotterItem, setSelectedScreenshotterItem] = useState<ScreenshotterItem | null>(null);
  const [filteredScreenshotterItems, setFilteredScreenshotterItems] = useState<ScreenshotterItem[]>([]);
  const [activeView, setActiveView] = useState<ActiveView>('manage');

  const { data: screenshotterItems, isLoading: isLoadingScreenshotterItems, isError: isErrorScreenshotterItems, refetch: refetchScreenshotterItems } = useGetScreenshotterItemsQuery();

  useEffect(() => {
    if (screenshotterItems) {
      setFilteredScreenshotterItems(screenshotterItems);
    }
  }, [screenshotterItems]);

  useEffect(() => {
    if (selectedScreenshotterItem) {
      console.log(selectedScreenshotterItem);
    }
  }, [selectedScreenshotterItem]);

  return (
    <div className="h-full flex flex-col space-y-4 p-6 pt-0 overflow-y-auto">
      <ScreenshotterMenuBar
        activeView={activeView}
        onCreated={() => {
          refetchScreenshotterItems();
        }}
        className='bg-gray-201 text-black rounded-full'
        selectedClassName='bg-blue-500 text-white'
        isFiltered={false}
        resultCount={0}
        totalCount={0}
        searchText={''}
        onSearchChange={() => {}}
      />

      {filteredScreenshotterItems.length > 0 ? (
        <ScreenshotterCards
          items={filteredScreenshotterItems}
          isLoading={false}
          onItemClick={(item) => {
            setSelectedScreenshotterItem(item);
          }}
        />
      ) : (
        <div className='flex items-center justify-center h-full'>
          <div className='flex flex-col items-center justify-center bg-white rounded-lg p-4 w-1/2 h-1/2'>
            <div className='flex flex-col items-center justify-center w-full h-full p-4 border border-gray-200 rounded-lg'>
              { screenshotterItems?.length === 0 ? (
                <div className='flex flex-col items-center justify-center w-full h-full'>
                  <MoveUpRight className='w-10 h-10 text-gray-500' />
                  <p className='text-gray-500'>
                    Click the button above to create a new screenshot.
                  </p>
                </div>
              ) : (
                <>
                  <Aperture className='w-10 h-10 text-gray-500' />
                  <p className='text-gray-500'>
                    No screenshots found.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ScreenshotterTab;
